import GenericRequest, { METHOD_POST } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../webservices/endpoint';

export class ResourceContractorSchemaListTask extends GenericRequest {

    _request; // ResourceContractorSchemaListRequest

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.DOCUMENTS_SCHEMAS);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/predefined-fields/resource-contractor-schema/ResourceContractorSchemaListTask.js